import React from 'react';

const SvgSt = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="ST_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ST_svg__b" fill="#fff">
        <use xlinkHref="#ST_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#ST_svg__a" />
      <path
        fill="#2ACB41"
        mask="url(#ST_svg__b)"
        d="M0 13.333h28V20H0zM0 0h28v6.667H0z"
      />
      <path fill="#FDD043" mask="url(#ST_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#E71E43" mask="url(#ST_svg__b)" d="M0 0l10.667 10L0 20z" />
      <path
        fill="#262626"
        mask="url(#ST_svg__b)"
        d="M14.667 11.093l-1.568 1.064.528-1.82-1.496-1.161 1.893-.06.643-1.783.642 1.782 1.894.061-1.497 1.162.528 1.82zM21.333 11.093l-1.567 1.064.528-1.82-1.497-1.161 1.894-.06.642-1.783.643 1.782 1.893.061-1.496 1.162.528 1.82z"
      />
    </g>
  </svg>
);

export default SvgSt;
